import "./Suppot.css";
import "./SupportMedia.css";
import { useEffect } from "react";
import { Nav } from "../../component/layout/nav/Nav";
import { Footer } from "../../component/layout/footer/Footer";
import InsideSacredWalls from "../../component/comman/insideSacredWalls/InsideSacredWalls";
import AOS from "aos";
import "aos/dist/aos.css";

export const Support = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <div className="support-heading">
        <div className="nav-support">
          <Nav />
        </div>
        <div className="support-heading-content" data-aos="fade-up">
          <h1>SUPPORT</h1>
          <h3>Adhie Annan Temple</h3>
          <p>
            At Adhie Annan Temple, we encourage all devotees to follow these
            guidelines to ensure a sacred, peaceful, and respectful spiritual
            experience. Kindly adhere to those instructions for the benefit of
            all visitors and to maintain the temple’s holiness.
          </p>
        </div>
      </div>
      <div className="support-section">
        <div className="support-container">
          <div className="support-contact-card" data-aos="fade-right">
            <h2>CONTACT</h2>
            <p>Welcome to Adhie Annan Temple! Contact us for assistance.</p>
            <ul>
              <li>
                <img src="/assets/image/support/phone.png" alt="phone" />
                +91 9080706050 <br />
                +91 9040302010
              </li>
              <li>
                <img src="/assets/image/support/mail.png" alt="mail" />
                contact@adhieannan.org
              </li>
              <li>
                <img src="/assets/image/support/location.png" alt="location" />
                JMPM+QVW, Kilvelur-Katchanam Rd, Katchanagaram, Tamil Nadu
                610207
              </li>
            </ul>
          </div>
          <div className="support-form" data-aos="fade-left">
            <form>
              <div className="form-row">
                <div data-aos="zoom-in">
                  <label>Name</label>
                  <input type="text" placeholder="Name" />
                </div>
                <div data-aos="zoom-in">
                  <label>Mail</label>
                  <input type="email" placeholder="Mail" />
                </div>
              </div>
              <div className="form-row">
                <div data-aos="zoom-in">
                  <label>Phone number</label>
                  <input type="text" placeholder="Phone number" />
                </div>
                <div data-aos="zoom-in">
                  <label>WhatsApp number</label>
                  <input type="text" placeholder="WhatsApp number" />
                </div>
              </div>
              <div className="form-row full">
                <div data-aos="fade-up">
                  <label>Message</label>
                  <textarea placeholder="Message" rows="4"></textarea>
                </div>
              </div>
              <div className="form-row full" data-aos="fade-up">
                <button type="submit">Send Message</button>
              </div>
            </form>
          </div>
        </div>
        <div style={{ marginTop: "32%" }} className="insideSacredWalls" data-aos="fade-up">
          <InsideSacredWalls />
        </div>
      </div>
      <Footer />
    </>
  );
};
